import React, { useEffect, useState } from "react";

import { useSelector } from "react-redux";
import { Space, Spinner } from "@masterteam/mt-design-react";

import Statuses from "../Dashboard/Statuses";
import SummaryCharts from "../Dashboard/SummaryCharts";
import DashboardHeader from "../Dashboard/DashboardHeader";
import LevelTwoObjectivesPerformance from "../Dashboard/LevelTwoObjectivesPerformance";

import api from "../../providers/api";
import { addToast } from "../../helpers";

import "./style.scss";

const LevelTwoObjectivesDashboard = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [filtersLoading, setFiltersLoading] = useState(false);
  const [data, setData] = useState(null);
  const [kpiStatuses, setKpiStatuses] = useState([]);
  const [projectStatuses, setProjectStatuses] = useState([]);
  const [strategies, setStrategies] = useState([]);
  const [years, setYears] = useState([]);
  const [filters, setFilters] = useState({
    year: null,
    strategy: null,
    quarter: null
  });

  const quarters = useSelector(({ theme }) => theme.Quarters.item.Items);

  const getData = async () => {
    try {
      setIsLoading(true);
      const [dataRes] = await Promise.all([
        api.dashboard.getLevelTwoObjectivesPerformanceData({
          Strategy: filters?.strategy?.ID,
          Year: filters?.year?.Value,
          Quarter: filters?.quarter?.Value
        })
      ]);
      setData(dataRes.Data);
    } catch (err) {
      addToast.error(err.message, {
        toastId: "get-users-error"
      });
    } finally {
      setIsLoading(false);
    }
  };

  const getFiltersData = async () => {
    try {
      setFiltersLoading(true);
      const [strategiesRes, yearsRes, kpiStatusesRes, projectStatusesRes, filterDateRes] =
        await Promise.all([
          api.strategy.getAllStrategyByType({ StrategyType: 1 }),
          api.dashboard.getValidYears(),
          api.handshake.getKPIStatuses(),
          api.handshake.getProjectStatuses(),
        api.dashboard.getFilterDate()
        ]);
      setStrategies(strategiesRes.Data ?? []);
      setYears(
        yearsRes.Data?.map((e) => {
          return { Label: e, Value: e };
        })
      );

      setKpiStatuses(kpiStatusesRes?.Data);
      setProjectStatuses(projectStatusesRes?.Data);

      // const today = new Date();
      // const currentYear = today.getFullYear();
      // const currentQuarter = Math.floor((today.getMonth() + 3) / 3);

      setFilters({
        strategy: strategiesRes.Data[0],
        year: { Label: filterDateRes?.Data?.Year, Value: filterDateRes?.Data?.Year },
        quarter: quarters?.find((e) => +e.Value === filterDateRes?.Data?.Quarter),
      });
    } catch (err) {
      addToast.error(err.message, {
        toastId: "get-users-error"
      });
    } finally {
      setFiltersLoading(false);
    }
  };

  useEffect(() => {
    getFiltersData();
  }, []);

  useEffect(() => {
    if (filters.strategy && filters.year && filters.quarter) getData();
  }, [filters]);

  return filtersLoading ? (
    <div className="loader-container">
      <Spinner size="large" />
    </div>
  ) : (
    <Space
      className="level-two-objectives-dashboard"
      direction="vertical"
      size="large"
    >
      <DashboardHeader
        dashboardTitle="dashboards.level-two-objectives-performance"
        strategies={strategies}
        years={years}
        quarters={quarters}
        isLoading={isLoading || filtersLoading}
        filters={filters}
        setFilters={setFilters}
      />

      {isLoading ? (
        <div className="loader-container">
          <Spinner size="large" />
        </div>
      ) : (
        <>
          <Space
            direction="vertical"
            size="large"
            className="level-two-objectives-dashboard__body"
          >
            <SummaryCharts
              strategy={data}
              kpiStatuses={kpiStatuses}
              projectStatuses={projectStatuses}
              chartTitle1="dashboards.level-two-objectives-kpis-performance"
              chartTitle2="dashboards.level-two-objectives-projects-performance"
            />

            <LevelTwoObjectivesPerformance
              data={data}
              kpiStatuses={kpiStatuses}
              projectStatuses={projectStatuses}
            />
          </Space>

          <Statuses
            thresholds={kpiStatuses}
            projectStatuses={projectStatuses}
          />
        </>
      )}
    </Space>
  );
};

export default LevelTwoObjectivesDashboard;
